import styled from 'styled-components';
// import {device} from "../../theme/MediaQueries"
// import ThemeDefault from "../../theme/ThemeDefault";
import moment from 'moment';

import { Link } from 'react-router-dom'
import { useContext, useEffect, useState } from 'react';
import { SiteContext } from '../context/SiteContext';
import ThemeDefault from '../../theme/ThemeDefault';

const CardItemDiv = styled.div`
  width: 100%;
  padding-bottom: 65%;
  position: relative;
  box-shadow:
  2.8px 2.8px 2.2px rgba(0, 0, 0, 0.02),
  6.7px 6.7px 5.3px rgba(0, 0, 0, 0.028),
  12.5px 12.5px 10px rgba(0, 0, 0, 0.035),
  22.3px 22.3px 17.9px rgba(0, 0, 0, 0.042),
  41.8px 41.8px 33.4px rgba(0, 0, 0, 0.05),
  100px 100px 80px rgba(0, 0, 0, 0.07);
  border-radius: 2rem;
  transition: 300ms;
  background: rgb(133, 133, 133);


  &:hover {
    transform: scale(1.05);
  }

  & .CardImageWrap {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    border-radius: 2rem;
    overflow: hidden;
    z-index: 1;
    mix-blend-mode: multiply;
  }

  & .CardAvatarImage {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    object-fit: cover;
    z-index: -1;
  }

  & .CardLogoWrap {
    position: absolute;
    top: 1.6rem;
    left: 1.6rem;
    width: 30%;
    z-index: 3;
  }

  & .CardLogoWrap img {
    width: 100%;
  }

  & .CardAvatarWrapper {
    position: absolute;
    bottom: 1.6rem;
    left: 1.6rem;
    width: calc(100% - 4rem);
    text-align: left;
    color: #fff;
    line-height: 1;
    z-index: 3;
  }

  & .CardAvatarWrapper  h2 {
    margin: 0;
    line-height: 1.1
  }
  & .date {
    margin-bottom: 0.8rem;
  }


`

const Tags = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 1rem;
`

const Tag = styled.div`
  font-size: 1.1rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 0.4rem 0.8rem;
  background: ${ThemeDefault.primary};
  color: ${ThemeDefault.trueWhite};
  border-radius: 16px;
  line-height: 1;
  margin-right: 0.8rem;
  font-weight: 700;
`

const LinkChecker = ({isExternal, externalLink, to, id, isIsotope, isIsotopeAlt, ...props}) => {
  if (isExternal) {
    return (<a href={externalLink} target="_blank" rel="noreferrer" className={`${(isIsotope || isIsotopeAlt) ? 'iso-card' : "iso-card"} ${props.className}`} >{ props.children }</a>)
  } else {
    return (<Link to={`/post/${id}`} className={`${(isIsotope || isIsotopeAlt) ? 'iso-card' : "iso-card"} ${props.className}`} >{ props.children }</Link>)
  }
}

export default function PostCardItem( {showLogo = false, collID, post, showTag = false, isIsotope, isIsotopeAlt, host = false} ) {

const {
    collectionsData,
    tokensData,
    tagData
  } = useContext(SiteContext)

  const day = moment(post.date.seconds * 1000);
  // console.log(day);

  // const colID = collID ? collID : post.collectionID[0];
  // const image = colID.replaceAll('-', '')
// const fullImage = (image === 'asmbrains' || image === 'partybear') ? image + '.png' : image + '.svg';

  const [fullImage, setFullImage] = useState(null)

  useEffect(() => {
    let abortController = new AbortController();
    setFullImage( () => {
        let col = (post.postLogoTokenParent && post.postLogoTokenParent !== '') ? 
        ( (tokensData && tokensData.length > 0) ? tokensData.filter((token) => { return token.id === post.postLogoTokenParent; }).reduce(arr => arr) : null ) :
        ( (collectionsData && collectionsData.length > 0) ? collectionsData.filter((collection) => { return collection.id === post.postLogoParent; }).reduce(arr => arr) : null );

        return (col ? col.logo : null)
      }
    )
    return () => abortController.abort();  
  }, [collectionsData, tokensData, post])


  return (
    <LinkChecker isExternal={post.isExternalLink} isIsotope={isIsotope} isIsotopeAlt={isIsotopeAlt} externalLink={post.externalLink} id={post.id} className={`${(post.tags.map((tag)=> { return tagData.filter(t => { return (parseInt(t.id) === parseInt(tag))}).reduce(arr => arr).slug } ).join(' '))} post-item`}>
      <CardItemDiv>
        <div className="CardImageWrap">
          <img src={post.bannerImage} className="CardAvatarImage" alt={`${post.name}`} />
        </div>
        <div className="CardAvatarWrapper">
          {showTag && <Tags className="showTags">
            { post.tags.map((tag) => {
              return (<Tag key={`${Math.random()}-${tag.id}`} className="tag">{tagData.filter(t => { return (parseInt(t.id) === parseInt(tag))}).reduce(arr => arr).title}</Tag>)})}
          </Tags> }
          <div className="date">{day.format("Do MMMM YYYY")}</div>
          <h2>{post.title}</h2>
          { post.host && <div className="host" style={{marginTop: "0.8rem"}}>With {post.host}</div> }
        </div>
        {showLogo && <div className="CardLogoWrap">
          <img className="CardCollectionLogo" src={fullImage} alt={`${post.name} Logo`} title={`${post.name} Logo`} />
        </div>}
      </CardItemDiv>
    </LinkChecker>
  )
}

